import React from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
import { bonuses, bonusesTotalValue } from '../data/bonuses';
export function BonusSection() {
  return <section className="py-24 px-4 bg-base" data-id="element-16" data-mp="22f3dzf1jrfnk">
      <div className="max-w-5xl mx-auto" data-id="element-17" data-mp="1ye1m5j9ym5vm">
        <div className="text-center mb-16" data-id="element-18" data-mp="1yfctft2m5vrh">
          <p className="text-olive font-bold tracking-widest uppercase mb-2" data-id="element-19" data-mp="1yc6zo0j1i5pf">
            Included without extra cost
          </p>
          <h2 className="text-4xl md:text-5xl font-display font-extrabold text-ink" data-id="element-20" data-mp="15q5ifulz3dpc">
            The <span className="text-brand" data-id="element-21" data-mp="1jhanxdc0v07l">5 Strategic Bonuses</span>
          </h2>
          <p className="text-graphite mt-4" data-id="element-22" data-mp="1eq2ewieltguy">
            Each bonus is included so your teaching week is lighter, clearer, and better organized.
          </p>
        </div>
        <div className="grid md:grid-cols-2 gap-6 mb-12" data-id="element-23" data-mp="qyn9ggrj6jfh">
          {bonuses.map((bonus, index) => <motion.div key={bonus.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className="bg-paper border border-silver-light rounded-2xl p-8 relative flex flex-col" data-id="element-24" data-mp="mws7rb5ou416" data-mpi={index}>
              <div className={`absolute top-0 right-0 px-4 py-2 rounded-bl-2xl rounded-tr-2xl font-bold text-sm ${bonus.tagClass}`} data-id="element-25" data-mp="2og7q8wydkr0t">
                BONUS {bonus.id}
              </div>
              <div className={`w-12 h-12 border rounded-full flex items-center justify-center mb-6 ${bonus.iconClass}`} data-id="element-26" data-mp="1vu4zf5blhfaz">
                <Gift size={24} aria-hidden="true" data-id="element-27" data-mp="25r9e6k3428hr" />
              </div>
              <h3 className="text-xl font-display font-extrabold mb-2 pr-24 text-ink" data-id="element-28" data-mp="3c73btcc8mpzm">
                {bonus.title}
              </h3>
              <div className="inline-flex flex-wrap items-center gap-2 bg-cream border border-silver-light px-3 py-1 rounded mb-4 self-start" data-id="element-29" data-mp="3h43gbitfvkom">
                <span className="text-graphite-light text-sm" data-id="element-30" data-mp="1c4as2v9t35dq">
                  Real value: <span className="line-through" data-id="element-31" data-mp="1c6evlc3sm2dh">${bonus.value}</span>
                </span>
                <span className="text-accent-dark font-bold" data-id="element-32" data-mp="1q3af5yho7c7s">→ FREE</span>
              </div>
              <p className="text-graphite text-sm mb-6 leading-relaxed flex-grow" data-id="element-33" data-mp="1m39rroclfqol">{bonus.desc}</p>
              <p className="text-olive text-sm italic font-medium mt-auto" data-id="element-34" data-mp="ydfithveam9m">{bonus.benefit}</p>
            </motion.div>)}
        </div>
        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="bg-paper border border-gold/50 rounded-2xl p-8 text-center max-w-2xl mx-auto" data-id="element-35" data-mp="174z9rhtsjru1">
          <p className="text-graphite mb-2" data-id="element-36" data-mp="ama2l1ljlrys">Total value of all 5 bonuses</p>
          <p className="text-2xl text-graphite-light line-through mb-4" data-id="element-37" data-mp="iuykewwl1dr">{bonusesTotalValue}</p>
          <p className="text-lg text-ink mb-2" data-id="element-38" data-mp="59ux1olo7rid">Your price today</p>
          <p className="text-5xl font-bold text-accent mb-4" data-id="element-39" data-mp="5c7n6p1l186i">FREE</p>
          <p className="text-sm text-olive" data-id="element-40" data-mp="3mrxj0ewey65y">Included in this offer only.</p>
        </motion.div>
        <CountdownTimer data-id="element-41" data-mp="3rqh7on2e5w20" />
      </div>
    </section>;
}